<template>
  <div class="row">
    <div class="col-md-12 pt-0 pb-0">
      <h6>
        <span class="text-muted">MEDICAMENTO:</span>
        {{ stock_sale.medicine_name }}
      </h6>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <h6>
        <span class="text-muted">VALOR DA VENDA:</span>
        {{ formatReal(String(stock_sale.value)) }}
      </h6>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <h6>
        <span class="text-muted">GRUPO:</span>
        {{ stock_sale.stock_group_name }}
      </h6>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <h6>
        <span class="text-muted">LOTE:</span>
        {{ stock_sale.lot }}
      </h6>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <h6>
        <span class="text-muted"
          >{{ stock_sale.stock_item_unit_of_measurement_abbreviation }}:</span
        >
        {{ stock_sale.amount }}
        {{ stock_sale.stock_item_unit_of_measurement_abbreviation }}
      </h6>
    </div>
    <div v-if="stock_sale.description" class="col-md-12 pt-0 pb-0">
      <h6>
        <span class="text-muted">DESCRIÇÃO:</span>
        {{ stock_sale.description }}
      </h6>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <h6>
        <span class="text-muted">DATA DA VENDA:</span>
        {{ moment(stock_sale.date).format("DD/MM/YYYY") }}
      </h6>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-12 text-center">
      <v-btn-save
        class="btn-block"
        :disabled="loading"
        :loading="loading"
        text="GERAR MOVIMENTAÇÃO"
        @click="execute"
      />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages.vue";

import VBtnSave from "../../../../Components/VBtnSave.vue";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

import moment from "moment";
import { formatReal } from "../../../../../lib/format";

export default {
  name: "Status",

  components: {
    ErrorsMessages,
    VBtnSave,
  },

  props: {
    stock_sale: Object,
  },

  data() {
    return {
      loading: false,

      errors: [],
    };
  },

  created() {},

  methods: {
    moment,
    formatReal,

    async execute() {
      try {
        this.loading = true;

        const {
          stock_sale: { id },
        } = this;

        let params = { id };

        const response = await api.put(
          "/rest-home/family/menu-rest-home-sale-resident",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("status");
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
